
jQuery(function($){
    

    //    < ------------------------------------------------------>
    // Menu
            jQuery(".mobileMenuIcon").click(function(){
                jQuery(".mainmenuSec").addClass("mainmenuSecOpen");
            });
            jQuery(".desktopMenuClose").click(function(){
                jQuery(".mainmenuSec").removeClass("mainmenuSecOpen");
            });

      //    < ------------------------------------------------------> 
  
       // Blog Slider
//     $('.productSlider').owlCarousel({
//         loop:true,
//         margin:20,
//         dots: false,
//         responsiveClass:true,
//         responsive:{
//             0:{
//                 items:1,
//                 nav:true
//             },
//             420:{
//                 items:2,
//                 nav:true
//             },
//             600:{
//                 items:3,
//                 nav:true
//             }
//         }
//     });
    //    < ------------------------------------------------------>
     

      
    });